import {Image, Platform, Text, TouchableOpacity, View} from 'react-native';
import React, {useState} from 'react';
import {useTheme} from 'contexts/ThemeContext';
import DropDownListForWeb from '../dropDownListForWeb';
import DropDownCalendarForWeb from '../dropDownCalendatForWeb';
import {PickerButtonProps} from '.';
import styleSheet from './styles';

const PickerButton = (props: PickerButtonProps) => {
  const styles = styleSheet(useTheme());
  const theme = useTheme();

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const onHandle = (title: string) => {
    props.onValueChange?.(title);

    setIsOpen(!isOpen);
  };

  const onDayPress = (value: Date) => {
    setIsOpen(!isOpen);

    props.onDayPress?.(value);
  };

  const pickerButton = (
    <TouchableOpacity
      onPress={toggle}
      activeOpacity={0.7}
      style={
        isOpen
          ? [
              styles.selectedPickerButtonStyle,
              props.pickerButtonStyle ? props.pickerButtonStyle : {},
            ]
          : [
              styles.pickerButtonStyle,
              props.pickerButtonStyle ? props.pickerButtonStyle : {},
            ]
      }>
      <View style={styles.leftSideContainerStyle}>
        {props.withoutButtonIcon ? null : (
          <Image
            source={props.icon}
            resizeMode="contain"
            style={styles.iconButtonStyle}
          />
        )}

        <Text style={styles.pickerValueStyle}>{props.pickerValue}</Text>
      </View>

      {props.downArowIcon ? (
        <Image source={theme.images.downArrowIcon} style={styles.arrowStyle} />
      ) : null}
    </TouchableOpacity>
  );

  return (
    <View
      style={[
        styles.defaultpickerContainerStyle,
        props.pickerContainerStyle,
        props.zIndex,
      ]}>
      <Text style={styles.pickerLabelStyle}>{props.pickerLabel}</Text>

      {pickerButton}

      {props.isWebCalendar ? (
        <DropDownCalendarForWeb
          onDayPress={onDayPress}
          startDate={props.startDate}
          endDate={props.endDate}
          isSecondCalendar={props.isSecondCalendar}
          isOpen={isOpen}
          calendarContainerStyle={styles.calendarContainerStyle}
        />
      ) : (
        <DropDownListForWeb
          isOpen={isOpen}
          data={props.data}
          onPress={value => onHandle(value)}
          label={props.pickerValue}
          pickerContainerStyle={[styles.flatListStyle, props.dropDownListStyle]}
          isDurationList={props.isDurationList}
        />
      )}
    </View>
  );
};

export default PickerButton;
